function SvgComponent(props) {
  return (
    <svg
      width="23"
      height="16"
      viewBox="0 0 23 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2864_2978)">
        <path
          d="M7.84798 15.3881C11.8509 15.3881 15.096 12.0802 15.096 7.99971C15.096 3.91922 11.8509 0.611328 7.84798 0.611328C3.84502 0.611328 0.599976 3.91922 0.599976 7.99971C0.599976 12.0802 3.84502 15.3881 7.84798 15.3881Z"
          stroke="#F2A474"
          stroke-width="1.5"
          stroke-miterlimit="10"
        />
        <path
          d="M15.152 15.3881C19.155 15.3881 22.4 12.0802 22.4 7.99971C22.4 3.91922 19.155 0.611328 15.152 0.611328C11.149 0.611328 7.90399 3.91922 7.90399 7.99971C7.90399 12.0802 11.149 15.3881 15.152 15.3881Z"
          stroke="#F2A474"
          stroke-width="1.5"
          stroke-miterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_2864_2978">
          <rect width="23" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgComponent;
